module.exports = __webpack_public_path__ + "media/welcome_2.01ba5f00.mp3";